import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
// import moment from "moment";

import EmailListing from "./EmailListing";
import Button from "../../components/Button/Button";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPen } from "@fortawesome/free-solid-svg-icons";

import { getList } from "../../store/ducks/email/actions";
import { filterErrorHandler } from "../../hoc/Shared/utility";
// import Select from "../../components/Input/Select/Select";

const initialInputState = {
    /* form input value */
    filter_date: "",
    email: "",
    otp_code: "",
    username: ""
};

let emailData = {};
class Email extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageShow: this.props.location.state === undefined ? "listing" : this.props.location.state.pageShow,

            page: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            sorted: null,
            totalPages: 0,
            activePage: 1,
            totalRecords: 0,

            loading: true,

            data: [],

            dropDown: [],

            filter: initialInputState,

            isOpen: false,
            currentAdminId: "",

            permission: [],
        };
    }

    fetchData() {
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        Object.keys(this.state.filter).forEach((val) => {
            // listingArr[val] = this.state.filter[val];
            // adminData[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });

        emailData.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        emailData.limit = this.state.limit;
        emailData.order = JSON.stringify(this.state.sorted);
        emailData.lang_id = this.props.currentLanguageId;
        emailData.country_id = this.props.currentCountryId;
        emailData.email = this.state.filter.email;
        emailData.otp_code = this.state.filter.otp_code;
        emailData.username = this.state.filter.username;
        emailData.filter_date = this.state.filter.filter_date;
        this.props.getList(emailData);
    }

    componentDidMount() {
        if (this.state.pageShow !== "show") {
            this.fetchData();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            // let adminPermission = this.props.currentPermission.filter((item) => item.includes("admin_"));
            this.setState({ permission: this.props.currentPermission });
        }

        if (nextProps.email_otp_data !== this.props.email_otp_data) {
            if (nextProps.email_otp_data.responseCode === 200 && nextProps.email_otp_data.msgType === "success") {
                this.setState({
                    loading: false,
                    data: nextProps.email_otp_data.data,
                    totalRecords: nextProps.email_otp_data.totalRecords,
                    totalPages: nextProps.email_otp_data.totalPages,
                });
            } else {
                this.setState(
                    {
                        loading: false,
                        data: [],
                        totalRecords: 0,
                        totalPages: 1,
                    },
                    () => {
                        filterErrorHandler(nextProps.email_otp_data.message);
                    }
                );
            }
        }
        // if (nextProps.delete_admin_result !== this.props.delete_admin_result) {
        //     const { t } = this.props;
        //     Swal.fire({
        //         title: t("global.record-deleted"),
        //         icon: nextProps.delete_admin_result.msgType,
        //         confirmButtonText: t("global.ok"),
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             this.fetchData();
        //         }
        //     });
        // }

        if (nextProps.update_status_admin_result !== this.props.update_status_admin_result) {
            if (nextProps.update_status_admin_result.responseCode === 200 && nextProps.update_status_admin_result.msgType === "success") {
                const { t } = this.props;
                Swal.fire({
                    title: nextProps.update_status_admin_result.message[0],
                    icon: nextProps.update_status_admin_result.msgType,
                    confirmButtonText: t("global.ok"),
                });
                this.fetchData();
            } else {
                this.setState(
                    {
                        loading: false,
                    },
                    () => {
                        filterErrorHandler(nextProps.update_status_admin_result.message);
                    }
                );
            }
        }
        return true;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence;

        if (order === "asc") {
            orderSequence = true;
        } else {
            orderSequence = false;
        }

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState({ sorted: orderArry, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    actionFormatter = (cell, row) => {
        let viewButton, editButton, output;

        if (this.state.permission.includes("admin_show")) {
            viewButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-white mr-2"
                    buttonName={<FontAwesomeIcon icon={faSearch} />}
                    key={`view-${row.Id}`}
                    clicked={() => this.changePageHandler("show", row.Id)}
                />
            );
        }

        if (this.state.permission.includes("admin_update")) {
            editButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-white"
                    buttonName={<FontAwesomeIcon icon={faPen} />}
                    key={`edit-${row.Id}`}
                    clicked={() => this.changePageHandler("edit", row.Id)}
                />
            );
        }

        // if (this.state.permission.includes("admin_delete")) {
        // deleteButton =
        //     <Button
        //         typeButton="button"
        //         classValue="btn btn-sm btn-danger mr-2"
        //         clicked={(event) => this.deleteAdminHandler(event, row.Id)}
        //         key={`delete-${row.Id}`}
        //         buttonName={<FontAwesomeIcon icon={faTrash}/>}
        //     />;
        // }
        output = [viewButton, editButton];
        return output;
    };

    onInputChange(event) {
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if (event.target.id === "filter_date") {
            const date = event.target.value !== "" ? event.target.value.split(" - ") : null;
            newFilter["start_date"] = date ? date[0] : "";
            newFilter["end_date"] = date ? date[1] : "";
        }

        this.setState({
            filter: newFilter,
        });
    }

    refreshHandler = () => {
        this.setState(
            {
                loading: true,
                data: [],
                sorted: null,
                activePage: 1,
            },
            () => {
                this.fetchData();
            }
        );
    };

    clearHandler = () => {
        this.setState(
            {
                activePage: 1,
                filter: initialInputState,
                loading: true,
                data: [],
            },
            () => {
                this.fetchData();
            }
        );
    };

    changePageHandler = (page, Id) => {
        this.setState({
            pageShow: page,
            currentAdminId: Id,
        });
    };

    pageChangeHandler = (activePage) => {
        this.setState({ page: activePage, activePage: activePage, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    sizePerPageHandler = (limit) => {
        this.setState({ limit: limit, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    postSearchHandler = () => {
        this.setState({ loading: true, data: [], activePage: 1 }, () => {
            this.fetchData();
        });
    };

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({ loading: true, data: [], activePage: 1 }, () => {
                this.fetchData();
            });
        }
    };

    noFormatter = (cell, row, rowIndex) => {
        //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        let rowNumber = this.state.totalRecords - rowIndex - (this.state.activePage - 1) * this.state.limit;
        return <span>{rowNumber}</span>;
    };

    render() {
        const { t } = this.props;
        let rsListing = [];
        let columns = [];

        columns = [
            {
                text: t("global.no"),
                dataField: "",
                keyField: "no",
                formatter: this.noFormatter,
                headerStyle: () => {
                    return { width: "60px" };
                },
            },
            {
                text: t('sms.create-date'),
                keyField: "created_at",
                dataField: "created_at"
            },
            {
                text: t("sms.username"),
                keyField: "username",
                dataField: "username",
            },
            {
                text: t("sms.email"),
                keyField: "email",
                dataField: "email",
            },
            {
                text: t("sms.otp-code"),
                keyField: "otp_code",
                dataField: "otp_code",
            },

            {
                text: t("sms.status"),
                dataField: "status",
                keyField: "status",
            },

            {
                text: t("sms.used"),
                dataField: "used",
                keyField: "used",
            },

            {
                text: t("sms.expiry-date"),
                dataField: "expiry_date",
                keyField: "created_at",
            },
        ];

        rsListing = this.state.data.map((val, idx) => {
            return {
                no: idx,
                created_at: val.created_at,
                username: val.username,
                email: val.email,
                otp_code: val.otp_code,
                status: val.status === 1 ? "Active" : "Inactive",
                used: val.used === 1 ? "Used" : "Unused",
                expiry_date: val.expiry_date,
            };
        });

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <div>
                        <div className="breadcrumb-header">
                            <div className="my-auto">
                                <div className="d-flex">
                                    <h4 className="text-muted mt-1 tx-13 ml-2 mb-0">{t("sms.email-title")}</h4>
                                </div>
                            </div>
                        </div>
                        <EmailListing
                            filter_date={this.state.filter.filter_date}
                            username={this.state.filter.username}
                            email={this.state.filter.email}
                            otp_code={this.state.filter.otp_code}
                            onInputChange={(event) => this.onInputChange(event)}
                            clearHandler={() => this.clearHandler()}
                            refreshHandler={() => this.refreshHandler()}
                            columns={columns}
                            activePage={this.state.activePage}
                            limit={this.state.limit}
                            totalRecords={this.state.totalRecords}
                            data={rsListing}
                            order={this.state.sorted}
                            pageChangeHandler={this.pageChangeHandler}
                            sizePerPageHandler={this.sizePerPageHandler}
                            postSearchHandler={this.postSearchHandler}
                            searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                            loading={this.state.loading}
                            permission={this.state.permission}
                            /**filter drop down*/
                            changePageHandler={this.changePageHandler}
                        />
                    </div>
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { emailOtp, currentUser } = state;

    return {
        email_otp_data: emailOtp.rs,
        currentPermission: currentUser.data.permission,
        currentCountryId: currentUser.data.country_id,
        currentLanguageId: currentUser.data.language_id,
    };
};

const mapDispatchToProps = {
    getList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Email));
